import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import LanguageSwitcher from './LanguageSwitcher';
import { Menu, X } from 'lucide-react';

const Header = ({ t, currentLang, onLanguageChange }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMobileMenuOpen(false);
  };

  const goToApply = () => {
    navigate('/apply');
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-red-900/20">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => navigate('/')}>
            <div className="flex items-center gap-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_job-albania-de/artifacts/d1x1sky4_e4cb23c6-1b36-435e-bad7-f845dd3a306e.jpg" 
                alt="ATG - Majestic Workforce" 
                className="h-16 w-auto object-contain"
              />
              <div className="hidden lg:block border-l border-gray-700 pl-4">
                <div className="font-bold text-xl text-white leading-tight">Majestic Workforce</div>
                <div className="text-sm text-gray-400">Albania to Europe</div>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              {t.nav.home}
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              {t.nav.about}
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              {t.nav.services}
            </button>
            <button onClick={() => scrollToSection('jobs')} className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              {t.nav.jobs}
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              {t.nav.testimonials}
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-300 hover:text-orange-500 transition-colors font-medium">
              {t.nav.contact}
            </button>
          </nav>

          {/* Right Side - Language Switcher & CTA */}
          <div className="flex items-center gap-4">
            <LanguageSwitcher currentLang={currentLang} onLanguageChange={onLanguageChange} />
            <Button onClick={goToApply} className="hidden md:inline-flex bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 text-white border-0">
              {t.hero.cta2}
            </Button>
            
            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 text-gray-300"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-red-900/20">
            <nav className="flex flex-col gap-4">
              <button onClick={() => scrollToSection('home')} className="text-left text-gray-300 hover:text-orange-500 transition-colors font-medium">
                {t.nav.home}
              </button>
              <button onClick={() => scrollToSection('about')} className="text-left text-gray-300 hover:text-orange-500 transition-colors font-medium">
                {t.nav.about}
              </button>
              <button onClick={() => scrollToSection('services')} className="text-left text-gray-300 hover:text-orange-500 transition-colors font-medium">
                {t.nav.services}
              </button>
              <button onClick={() => scrollToSection('jobs')} className="text-left text-gray-300 hover:text-orange-500 transition-colors font-medium">
                {t.nav.jobs}
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="text-left text-gray-300 hover:text-orange-500 transition-colors font-medium">
                {t.nav.testimonials}
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-left text-gray-300 hover:text-orange-500 transition-colors font-medium">
                {t.nav.contact}
              </button>
              <Button onClick={goToApply} className="bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700 w-full text-white border-0">
                {t.hero.cta2}
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
